import * as flights from '../../flights';

export class StopCountFilter {
    none = false;
    one = false;
    two = false;

    get touched(): boolean {
        return this.none || this.one || this.two;
    }

    clear() {
        this.none = false;
        this.one = false;
        this.two = false;
    }

    check(flight: flights.FlightModel): boolean {
        let result = true; // By default filter is not applied

        if (this.none || this.one || this.two) {
            result = false; // Filter defined so hide flight by default

            let maxStopCount = 0;

            flight.legs.forEach(l => {
                const stopsCount = l.segments.length - 1;

                if (stopsCount > maxStopCount) {
                    maxStopCount = stopsCount;
                }
            });

            if (this.none && maxStopCount === 0) {
                return true;
            }

            if (this.one && maxStopCount === 1) {
                return true;
            }

            if (this.two && maxStopCount > 1) {
                return true;
            }
        }

        return result;
    }
}
